import React, { Component } from "react";

import { Container } from "reactstrap";
import Breadcrumbs from "../../../../components/Common/Breadcrumb";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { addCampaignCashback } from "../../../../store/campaigns/cashbacks/actions";
import { getCampaignSourcesList } from "../../../../store/campaigns/sources/actions";
import { getServiceProvidersList } from "../../../../store/service-provider/actions"
import { getMetaCountries } from "../../../../store/meta/actions";
import CampaignCashbackBlock from "../components/CampaignCashbackBlock";
import ModifiedMetaTags from '../../../../components/ModifiedMetaTags/index';

class CashbacksAddPage extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.props.getMetaCountries();
    this.props.getCampaignSourcesList({
      ...this.props.sources,
      sizePerPage: 0,
    });
    this.props.getServiceProvidersList({
      ...this.props.service_providers,
      sizePerPage: 0,
    })
  }

  saveChanges = data => {
    this.props.addCampaignCashback(data);
    this.props.history.push(`/cashbacks`);
  };

  render() {
    const history = this.props.history;

    return (
      <React.Fragment>
        <div className="page-content">
          <ModifiedMetaTags title="Add cashback  | Mobihunter" />

          <Container fluid>
            <Breadcrumbs
              title="Campaign cashbacks"
              breadcrumbItem="Add cashback"
              link="/cashbacks"
            />
            {this.props.countries && (
              <CampaignCashbackBlock
                cashback={{}}
                countries={this.props.countries}
                saveChangeAction={this.saveChanges}
                history={history}
                service_providers_loading={this.props.service_providers_loading}
                service_providers={
                  this.props.service_providers
                    ? [
                      {
                        label: 'None',
                        value: null
                      }
                      ,
                      ...this.props.service_providers?.results.map(i => {
                        return {
                          label: i.counterparty_name,
                          value: i.id,
                        };
                      })
                    ]
                    : []
                }
                sources_loading={this.props.sources_loading}
                sources={
                  this.props.sources
                    ? this.props.sources?.results.map(i => {
                      return {
                        label: i.name,
                        value: i.id,
                      };
                    })
                    : []
                }
                loading={this.props.loading}
              />
            )}
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

CashbacksAddPage.propTypes = {
  addCampaignCashback: PropTypes.func,
  getMetaCountries: PropTypes.func,
  history: PropTypes.any,
  countries: PropTypes.any,
  loading: PropTypes.bool,
  sources: PropTypes.object,
  sources_loading: PropTypes.bool,
  service_providers: PropTypes.object,
  service_providers_loading: PropTypes.bool,
  getCampaignSourcesList: PropTypes.func,
  getServiceProvidersList: PropTypes.func,
};

const mapStateToProps = state => ({
  service_providers: state.ServiceProviders.data,
  service_providers_loading: state.ServiceProviders.loading_list,
  sources: state.CampaignSourceList.data,
  countries: state.Meta.countries,
  sources_loading: state.CampaignCashbackList.loading,
  loading: state.CampaignCashbackList.loading,
});

export default withRouter(
  connect(mapStateToProps, {
    addCampaignCashback,
    getMetaCountries,
    getCampaignSourcesList,
    getServiceProvidersList,
  })(CashbacksAddPage)
);
